export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="flex-1 p-6 md:p-10 text-center lg:text-left">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                  手机看片
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                  夜猫电影院全端适配，躺在床上用手机也能享受流畅高清观影。无论你是窝在被窝里追剧，还是通勤路上看预告片，打开浏览器即可秒速观看，无需下载 App。
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <div className="inline-flex items-center gap-3 px-5 py-3 bg-primary-500 text-background-50 rounded-lg cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors">
                    <i className="ri-smartphone-line text-lg"></i>
                    <span className="text-sm font-semibold">手机端直接访问</span>
                  </div>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    浏览器打开即可，无需安装
                  </span>
                </div>

                <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
                  <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                    自适应画质
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                    观影进度同步
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                    收藏与历史记录
                  </div>
                </div>
              </div>

              <div className="flex-1 p-6 md:p-0">
                <div className="relative max-w-[280px] mx-auto">
                  <div className="bg-background-200 rounded-3xl p-3 border-4 border-background-300">
                    <div className="aspect-[9/16] rounded-2xl overflow-hidden bg-background-50 relative">
                      <img
                        src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20mockup%20showing%20movie%20streaming%20app%20interface%20with%20film%20thumbnails%20and%20warm%20dark%20theme%2C%20cinema%20app%20UI%20design%20with%20movie%20posters%20in%20grid%20layout%2C%20cozy%20night%20mode%20color%20scheme%20with%20amber%20and%20terracotta%20accents&width=400&height=700&seq=app-mockup-01&orientation=portrait"
                        alt="夜猫电影院手机端观影界面"
                        className="w-full h-full object-cover object-top"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}